const HeroSection = () => {
  return (
    <section className="relative min-h-screen bg-cream px-8 pt-32 pb-16 flex items-center">
      <div className="w-full h-[calc(100vh-8rem)] rounded-[24px] overflow-hidden relative mx-auto">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/f9c257a68cdc0387af9d5177549665cd.jpg"
            alt="Riverdale Hair Studio Interior"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        </div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-8">
          <div className="inline-block px-6 py-2 border border-white/40 rounded-full mb-6 backdrop-blur-sm">
            <span className="text-white text-sm font-sans font-medium tracking-wide">
              Otley's Premier Salon
            </span>
          </div>

          <h1 className="font-serif text-white mb-4 max-w-4xl">
            <span className="block text-7xl font-light tracking-wide">Where Style Meets</span>
            <span className="block text-7xl font-bold italic mt-2">Confidence</span>
          </h1>

          <p className="text-lg text-white/90 font-sans font-light tracking-wide mb-12 max-w-2xl">
            Expert cuts, colour, and styling in the heart of <strong>West Yorkshire</strong>
          </p>

          <a
            href="/contact"
            className="px-10 py-4 bg-sage text-white font-sans text-base font-medium rounded-full hover:bg-sage-dark transition-all hover:transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Book Your Appointment
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;